// extracted by mini-css-extract-plugin
export default {"clientInformation":"_1y1sS___ClientInformation-module__clientInformation","clientLogo":"_1jcMG___ClientInformation-module__clientLogo"};